import React, { Component } from 'react';
import Header from './components/header/Header';
import FoodGallery from './components/foodgallery/FoodGallery';
import firebase from './components/firebase/Firebase.js';

const itemsRef = firebase.database().ref('items');
const pwRef = firebase.database().ref('passwords');

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      foodItems: [],
      filter: 'Alle',
      search: '',
      password: 'initial'
    };

    this.sortItems = this.sortItems.bind(this);
    this.addItem = this.addItem.bind(this);
    this.setFilter = this.setFilter.bind(this);
    this.setSearch = this.setSearch.bind(this);
  }

  componentDidMount() {
    itemsRef.on('value', data => {
      let items = data.val();
      let newState = [];
      for (let item in items) {
        newState.push({
          id: item,
          name: items[item].name,
          src: items[item].src,
          rating: items[item].rating,
          category: items[item].category,
          time: items[item].time,
          count: items[item].count,
          ingredients: items[item].ingredients,
          description: items[item].description,
          steps: items[item].steps
        });
      }

      this.setState({
        foodItems: newState
      });

      pwRef.on('value', data => {
        let items = data.val();
        let password = '';
        password = items[0].password;
        this.setState({
          password
        });
      });
    });
  }

  sortItems(key, up) {
    const clickedTwice = up === true ? 1 : -1;
    const sortedItems = this.state.foodItems.sort((a, b) =>
      a[key] > b[key] ? clickedTwice : -1 * clickedTwice
    );
    this.setState({ foodItems: sortedItems });
  }

  setFilter(filter) {
    this.setState({ filter });
  }

  setSearch(search) {
    this.setState({ search });
  }

  addItem(item) {
    itemsRef.push({
      name: item.name,
      count: 0,
      time: item.time,
      rating: 0,
      src: item.src,
      category: item.category,
      ingredients: [{ ingredient: 'Zutat', amount: 'Menge' }, {}],
      steps: [{ step: 'Schritt', nr: '1' }]
    });
  }

  changeItem = (id, name, value) => {
    itemsRef.once('value', data => {
      let items = data.val();
      for (let item in items) {
        if (item === id) {
          itemsRef
            .child(id)
            .child(name)
            .set(value);
        }
      }
    });
  };

  render() {
    return (
      <div>
        <Header
          sortItems={this.sortItems}
          addItem={this.addItem}
          setFilter={this.setFilter}
          setSearch={this.setSearch}
        />
        <FoodGallery
          foodItems={this.state.foodItems}
          changeItem={this.changeItem}
          filter={this.state.filter}
          search={this.state.search}
          pass={this.state.password}
        />
      </div>
    );
  }
}
export default App;
